import Typography from '@mui/material/Typography';
import { StatusIndicator } from '@openx/components-core/lib/StatusIndicator/StatusIndicator';
import type { Segment } from '@openx/types/segments';
import { abbreviatedNumber } from '@openx/utils/lib/abbreviatedNumber';
import { useTranslation } from 'react-i18next';
import { mapStatus } from '../../utils/mapStatus';

type Props = {
  seed: { segment: Pick<Segment, 'id' | 'name' | 'reach' | 'status'> | null } | null;
};

export const SeedCell = ({ seed }: Props) => {
  const { t } = useTranslation();

  const segment = seed?.segment;
  const { name, status, reach } = segment ?? {};

  const mappedStatus = mapStatus(status);

  return (
    <>
      <Typography variant="body2">
        <Typography component="span" color="textSecondary" sx={{ marginRight: 1 }}>
          {t('Name')}:
        </Typography>
        {name ?? null}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        <Typography component="span" color="textSecondary" sx={{ marginRight: 1 }}>
          {t('Reach')}:
        </Typography>
        {reach ? abbreviatedNumber(reach) : null}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        <Typography component="span" color="textSecondary" sx={{ marginRight: 1 }}>
          {t('Status')}:
        </Typography>
        <StatusIndicator label={mappedStatus?.label} status={mappedStatus?.status} />
      </Typography>
    </>
  );
};
